import React, { useMemo } from "react";

import {
  AdminRuntimeContextProvider,
} from "./AdminRuntimeContext";

export default function AdminRuntimeProvider({
  children,
  workspace,
  getPanelConfig,
  isRegisteredPanel,
}) {
  const {
    activeTab,
    panelMode,
    panelContext,
    panelKey,
    isFullscreen,
    isPanelExpanded,
    changeTab,
    openPanel,
    closePanel,
    toggleFullscreen,
  } = workspace;

  const panelConfig = useMemo(
    () => getPanelConfig(panelMode),
    [getPanelConfig, panelMode]
  );

  const hasRegisteredPanel = useMemo(
    () => isRegisteredPanel(panelMode),
    [isRegisteredPanel, panelMode]
  );

  const runtimeValue = useMemo(
    () => ({
      activeTab,
      panelMode,
      panelContext,
      panelKey,
      panelConfig,
      isFullscreen,
      isPanelExpanded,
      hasRegisteredPanel,
      changeTab,
      openPanel,
      closePanel,
      toggleFullscreen,
    }),
    [
      activeTab,
      panelMode,
      panelContext,
      panelKey,
      panelConfig,
      isFullscreen,
      isPanelExpanded,
      hasRegisteredPanel,
      changeTab,
      openPanel,
      closePanel,
      toggleFullscreen,
    ]
  );

  return (
    <AdminRuntimeContextProvider value={runtimeValue}>
      {children}
    </AdminRuntimeContextProvider>
  );
}
